<template>
  <v-row v-if="usedConfig">
    <v-col>
      <v-alert type="warning">
        {{ usedConfig.message }} <br>
        <v-card flat color="transparent" :to="usedConfig.route" style="color: white; text-decoration: underline;"
          class="d-inline-flex">
          {{ usedConfig.openText }}
        </v-card>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click.stop="openUsedInNewTab()" icon v-bind="attrs" v-on="on">
              <v-icon size="18">mdi-open-in-new</v-icon>
            </v-btn>
          </template>
          <span v-text="$t('servicesystem.common_objects.document.open_in_new_tab')" />
        </v-tooltip>
      </v-alert>
    </v-col>
  </v-row>
</template>


<script>
export default {
  name: "UsedAlert",
  props: {
    usedConfig: Object,
  },
  components: {},
  mixins: [],

  data() {
    return {};
  },

  mounted() { },

  methods: {
    openUsedInNewTab() {
      let newPageRoute = this.$router.resolve(this.usedConfig.route);
      window.open(newPageRoute.href, "_blank");
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>